import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { DialogModule } from 'primeng/dialog';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { MembershipCodesService, MembershipCode } from '../../services/membership-codes.service';

@Component({
  selector: 'app-code-dialog',
  standalone: true,
  imports: [DialogModule, CalendarModule, FormsModule, ButtonModule, ReactiveFormsModule, InputTextModule, InputNumberModule, ToastModule],
  templateUrl: './code-dialog.component.html',
  styleUrl: './code-dialog.component.scss',
  providers: [MessageService]
})
export class CodeDialogComponent implements OnInit {
  @Input() isVisible = false;
  @Input() isEdit = false;
  @Input() code: MembershipCode | null = null;
  @Output() onClose = new EventEmitter<boolean>();

  form: FormGroup;
  isSubmitted = false;
  minDate: Date = new Date();

  constructor(
    private formBuilder: FormBuilder,
    private membershipCodesService: MembershipCodesService,
    private messageService: MessageService
  ) {
    this.form = this.formBuilder.group({
      organization: ['', Validators.required],
      expiresOn: ['', Validators.required],
      code: ['', [Validators.required, Validators.maxLength(20)]],
    });
  }

  ngOnInit(): void {
    if(this.isEdit && this.code) {
      this.form.patchValue({
        organization: this.code.organization,
        code: this.code.code,
        expiresOn: new Date(this.code.expiresOn),
      })
      this.form.get('code')?.disable();
    }
  }

  async submit() {
    this.isSubmitted = true;
    if(this.form.invalid) return;
    
    try {
      if(this.isEdit && this.code?.id) {
        await this.membershipCodesService.updateCode(this.code.id, this.form.value).toPromise();
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Code updated successfully' });
      } else {
        await this.membershipCodesService.createCode(this.form.value).toPromise();
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Code created successfully' });
      }
      this.onClose.emit(false);
    } catch (error) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error processing code' });
    }
  }

  generateCode() {
    const length = this.getRandomIntInclusive(7,10)
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    for (let i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    this.form.patchValue({code: result});
  }

  getRandomIntInclusive(min: number, max: number) {
    const minCeiled = Math.ceil(min);
    const maxFloored = Math.floor(max);
    return Math.floor(Math.random() * (maxFloored - minCeiled + 1) + minCeiled);
  }

  setTrial() {
    this.form.patchValue({expiresOn: new Date(new Date().setDate(new Date().getDate() + 7))});
  }

  set6Months() {
    this.form.patchValue({expiresOn: new Date(new Date().setMonth(new Date().getMonth() + 6))});
  }

  set1Year() {
    this.form.patchValue({expiresOn: new Date(new Date().setFullYear(new Date().getFullYear() + 1))});
  }
}
